import { useCallback, useState, useEffect,useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty, debounce, cloneDeep, isArray, has, isEqual } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../redux/slices/treeSlice";
import {
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Autocomplete,
  Alert,
  Snackbar,
} from "@mui/material";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { Stack } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { api } from "../../../redux/api";
import DatabaseFieldProperty from "./DataTypeComponents/DatabaseFieldProperty";
import FixedLengthFieldProperty from "./DataTypeComponents/FixedLengthFieldProperty";
import { t } from "i18next";
import DatePattern from "../PatternModal/DatePattern";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genericRules, validateOnFlow, validateRevertTime, validationTime } from "../../../utils/validate";
import EDIFieldProperty from "./DataTypeComponents/EDIFieldProperty";
import { useGetDatatypePropertiesQuery } from "../../../redux/api";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DelimiterDialog from "../../TemplateProperties/DelimiterDialog";
import DelimiterInput from "../../TemplateProperties/DelimiterInput";
import { fieldTypeOptionsArray, xmlTypeOptionsArray } from "../../../constants/constantList";
import { lgDocPath } from "../../../constants/languageDocPaths";
import { getNewRecordName } from "../../RightContextMenu/ContextActions/NewRecord";
import { getNewElementName } from "../../RightContextMenu/ContextActions/NewElement";
import { FieldPropHL7Datatype } from "./FieldPropHL7Datatype";
import { AddToDataDepot } from "./OutboundFieldFormattingOptions/AddToDataDepot";
const ValidationRulesXML ={
  ATTRIBUTE_NAME:{
    ...genericRules.alphaNumericForXML,
    message:{
      spaceInclude:t('BOX_ATTR_NAMES_CANNOT_HAVE_SPACE__CONSIDER_USING_UNDERSCORE'),
      firstNonNumeric:t('BOX_ATTR_NAMES_MUST_START_WITH_LETTER__MODIFY_ATTR_NM').split('.')[0],
      onlyAllowedSpecialCharacter:t('BOX_ATTR_NAMES_CANNOT_HAVE_SPECIAL_CHARS')

    }
  },
  ELEMENT_NAME:{
    ...genericRules.alphaNumericForXML,
    message:{
      spaceInclude:t('BOX_ELEM_NAMES_CANNOT_HAVE_SPACE__CONSIDER_USING_UNDERSCORE'),
      firstNonNumeric:t('BOX_ELEM_NAMES_MUST_START_WITH_LETTER__MODIFY_ELEM_NM').split('.')[0],
      onlyAllowedSpecialCharacter:t('BOX_ELEM_NAMES_CANNOT_HAVE_SPECIAL_CHARS')
    }
  }
}
export default function FieldPropertyForm(props) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const queryParams = useSelector((state) => state.queryParams);
  const account = queryParams.account;
  const templateHeader = rightTree.tree.templateHeader;
  const dispatch = useDispatch();

  // State management for form values.
  const [text, setText] = useState("");
  const [description, setDescription] = useState(
    selectedNode.DESCRIPTION || ""
  );
  const [fieldType, setFieldType] = useState('');
  const [fieldNumber, setFieldNumber] = useState(0);
  // const [depotField, setDepotField] = useState(selectedNode.DATA_DEPOT_FIELD ?[selectedNode.DATA_DEPOT_FIELD] : []);
  // const [dataDepotOptions, setDataDepotOptions] = useState(selectedNode.DATA_DEPOT ?[selectedNode.DATA_DEPOT] : []);
  // const [addDataDepot, setAddDataDepot] = useState(false);
  const [date, setDate] = useState('');
  // const [dataDepotValue, setDataDepotValue] = useState('');
  // const [dataFieldValue, setDataFieldValue] = useState('');
  const [precision, setPrecision] = useState('');
  const [isNumericField, setIsNumericField] = useState(false);
  const [isDateField, setIsDateField] = useState(false);
  const [flag,setFlag] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [fieldName, setFieldName] = useState();
  const [datePatternModal, setDatePatternModal] = useState(false);
  const [datePattern, setDatePattern] = useState('');
  const [valid,setValid] = useState(true);
  const [dpNetworkCallMessage,setDpNetworkCallMessage] = useState('')
  const [fieldTypeOptions,setFieldTypeOptions] = useState([]);
  const [fieldTypeDropDownItems,setFieldTypeDropDownItems] = useState()
  const [value,setValue] = useState('');
  const [length,setLength] = useState('');
  const [begin,setBegin] = useState('');
  const [end,setEnd] = useState('');
  const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
  // Field Delimiter
  const [fieldIdentifier, setFieldIdentifier] = useState(null);
  const [openFieldIdentifier, setOpenFieldIdentifier] = useState(false);
  // For XML
  const [attribute, setAttribute] = useState('');
  const [element, setElement] = useState('');
  const [repeatingElement, setRepeatingElement] = useState(false);

  const [arrayValue,setArrayValue] = useState(false);
  const [errors, setErrors] = useState({});

  // for HL7
//   const [hl7Datatype,setHl7Datatype] = useState('')
  const [repeatableField,setRepeatableField] = useState(false);
//   const [hl7DatatypeDropdownItems,sethl7DatatypeDropdownItems] = useState([t('SELECT')])
//   const hl7DatatypeOptions = useGetDatatypePropertiesQuery({
//     account:account,
//     report_type:'hl7',
//     version:templateHeader?.FILETYPE_VERSION
// });
  // Adding the "--select--" option to the HL7 data type dropdown
  // useEffect(()=>{
  //   sethl7DatatypeDropdownItems([t('SELECT'), ...hl7DatatypeOptions.data?.data || []]);
  // },[hl7DatatypeOptions])

  // Local variables
  const ele = selectedNode?.TYPE || selectedNode?.ELEMENT_NAME || '';
  const attr = selectedNode?.ATTRIBUTE_NAME || '';
  let mapNameMessage = t("BOX_INBOUND_FIELD_NAME_ALREADY_EXISTS");
  let head = mapNameMessage.split("{0}");
  let duplicateMapNameMessage = head[0].concat(fieldName, head[1]);
  let docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`;

  // Generates dropdown items for the 'data depot' dropdown.
  // const dataDepotDropDownItems = dataDepotOptions?.map((obj, key) => (
  //   <MenuItem key={key} value={obj}>
  //     {obj}
  //   </MenuItem>
  // ));
  // // Generates dropdown items for the 'data depot field' dropdown.
  // const dataFieldDropDownItems = depotField?.map((obj, key) => (
  //   <MenuItem key={key} value={obj?.name}>
  //     {obj?.name}
  //   </MenuItem>
  // ));

  // const dataFieldDropDownItems = depotField?.filter((obj) => obj !== undefined).map((obj, key) => (
  //   <MenuItem key={key} value={obj}>
  //     {obj}
  //   </MenuItem>
  // ));
 
  //use effects
  useEffect(() => {
    const changedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    if (changedNode) {
      setText(changedNode.MAPNAME || "");
      setDescription(changedNode.DESCRIPTION || changedNode.MAPNAME || "");
      setFieldType(changedNode.FIELDTYPE || "ALPHA");
      setFieldNumber(changedNode.fieldNumber || 0);
      setPrecision(changedNode.PRECISION ? Number(changedNode.PRECISION) : ["INTEGER", "PACKED_INT","ZONED_INT","FLOAT"].includes(changedNode?.FIELDTYPE) ? 0 : '' );
      // if(changedNode.DATA_DEPOT) setDataDepotValue(changedNode.DATA_DEPOT || "");
      // if(changedNode.DATA_DEPOT) setDataFieldValue(changedNode.DATA_DEPOT || '');
      setDate(changedNode.PATTERN || "");
      setDatePattern(selectedNode?.PATTERN ||'')
      setValue(changedNode?.VALUE || "");
      setLength(isNaN(changedNode?.LENGTH) ? '0' : changedNode?.LENGTH || '0');
      setBegin(changedNode?.BEGIN || '');
      setEnd(changedNode?.END || '');
      setFieldIdentifier(changedNode?.FIELD_ID || '');

      if(["HL7","MULIT_DELIMITED","EDI", "DELIM_FLD_ID","XML"].includes(templateHeader?.FILETYPE)){
      //  setHl7Datatype(changedNode?.DATA_TYPE || hl7DatatypeDropdownItems[0]);
       setRepeatableField(changedNode?.REPEATING === "TRUE" || false)// !! converts a string value to a boolean to prevent any warning messages from Material-UI
      }

      if (changedNode.ATTRIBUTE_NAME) setAttribute(changedNode.ATTRIBUTE_NAME);

      if (changedNode.TYPE) setElement(changedNode.TYPE);
      else if (changedNode.ELEMENT_NAME) setElement(changedNode.ELEMENT_NAME);

      if (changedNode.REPEATING && changedNode.REPEATING === 'TRUE') setRepeatingElement(true);
      else setRepeatingElement(false);

      if ("JSON" === templateHeader?.FILETYPE && (changedNode.REPEATING === true || ['true', "True", "TRUE"].includes(changedNode?.REPEATING))) setArrayValue(true);
      else setArrayValue(false);

      setDpNetworkCallMessage('')
      setValid(true)
    }

    // if (!selectedNode.DATA_DEPOT || !selectedNode.DATA_DEPOT_FIELD) {
    //   setAddDataDepot(false);
    // } else {
    //   setAddDataDepot(true);
    // }

    return () => {
      // setDataDepotValue('');
      // setDataFieldValue('');
    }


  }, [
    rightTree.tree[rightTree.currentTab].selectedNode.key,
    // selectedNode.DATA_DEPOT,
    // selectedNode.DATA_DEPOT_FIELD,
    // setAddDataDepot,
  ]);

  //old data depot logic hits endpoint every time.
  // useEffect(() => {
  //   if (addDataDepot) {
  //     dispatch(
  //       api.endpoints.getDataDepotList.initiate({
  //         account: queryParams.account,
  //       },{forceRefetch:true})
  //     ).then((response) => {
  //       if (response.data.current_state === "SUCCESS") {
  //         const depotList = Object.values(response.data?.data.data_depot_list)
  //         if(depotList.length > 0) {
  //           setDataDepotOptions(depotList);
  //           setDataDepotValue(selectedNode.DATA_DEPOT || depotList[0]);
  //           if (!selectedNode.DATA_DEPOT) {
  //             dataDepotHandler("DATA_DEPOT", depotList[0]);
  //             handleDataDepotChange(dataDepotValue);
  //           }
  //         }
  //       }
  //       if (response?.data?.current_state === "ERROR") setShowAlert({ mssg: response.data.message, isOpen: true, type: 'error' });
  //     });
  //   }
  // }, [addDataDepot]);

  // useEffect(() => {
  //   if (templateHeader.FILETYPE === "XML") {
  //     if (!selectedNode.REPEATING) setRepeatingElement(false);
  //     else setRepeatingElement(true);
  //   }
  // }, [setRepeatingElement]);

  // useEffect(() => {
  //   if (templateHeader.FILETYPE === "XML") {
  //     handleRepeatingElement(repeatingElement || false);
  //   }
  // }, [repeatingElement]);
 
  useEffect(()=>{
    setDatePattern(date)
  },[datePatternModal])
 
  useEffect(() => {
    const selectedNode = rightTree.tree[rightTree.currentTab]?.selectedNode;
    const isNumeric = ["INTEGER", "FLOAT", "ZONED_INT", "PACKED_INT"].includes(
      selectedNode?.FIELDTYPE
    );
    setIsNumericField(isNumeric);
    setIsDateField(selectedNode?.FIELDTYPE === "DATE");
    // if (dataDepotValue && selectedNode.hasOwnProperty("DATA_DEPOT_FIELD")) {
    //   handleDataDepotChange(selectedNode.DATA_DEPOT);
    //   setAddDataDepot(true)
    // }
    // if (!selectedNode.DATA_DEPOT || !selectedNode.DATA_DEPOT_FIELD) {
    //   setAddDataDepot(false);
    // } else {
    //   setAddDataDepot(true);
    // }
  }, [rightTree.tree[rightTree.currentTab]?.selectedNode]);

  // useEffect(() => {
  //   if (dataDepotValue) handleDataDepotChange(dataDepotValue);
  // }, [dataDepotValue]);

  useEffect(()=>{
    const fieldTypeDropDownItems = fieldTypeOptions.map((obj, key) => (
      <MenuItem key={key} value={obj.value}>
        {t(obj.text)}
      </MenuItem>
    ));
    setFieldTypeDropDownItems(fieldTypeDropDownItems);
  },[fieldTypeOptions])

  useEffect(()=>{
    const fieldTypeOptions = [...fieldTypeOptionsArray];
    if(templateHeader?.FILETYPE==="DATABASE"){
      fieldTypeOptions.splice(2,0,{
        value: "CONSTANT", 
        text: t("CONSTANT")
      })
    }
    if(templateHeader?.FILETYPE === 'HL7'){
      // setHl7Datatype(selectedNode.DATA_TYPE || hl7DatatypeDropdownItems[0]);
    }
    setFieldTypeOptions(fieldTypeOptions);
  },[templateHeader?.FILETYPE])
 
  useEffect(()=>{
   setValid(true);
   setDpNetworkCallMessage("");
  },[datePatternModal])
  
  // Functions
  const handlePatternPrecisionState = (e) => {
    const { value } = e.target;
    const isNumeric = ["INTEGER", "FLOAT", "ZONED_INT", "PACKED_INT"].includes(
      value
    );
    setIsNumericField(isNumeric);
    setIsDateField(value === "DATE");
  };

  // Handles opening and closing of date pattern modal.
  const datePatternModalCancelHandler = () => {
    setDatePatternModal(false);
  };

  const datePatternModalOkHandler = () => {

    if (flag) {
      setDate(datePattern);
      setDatePatternModal(!datePatternModal);
      debounceChangeHandler("PATTERN", datePattern);
    } else {
      setDate(selectedNode.PATTERN || date);
      setDatePatternModal(!datePatternModal);
    }
  };
  
  
  const testDateHandler = (key,val) => {
    if(!val){
      setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
      setValid(false)
    }
      if (val) {
        dispatch(
          api.endpoints.validateDatePattern.initiate({
            datePattern: encodeURIComponent(val),
          })
        ).then((response) =>{
          if(response){
            if(response.data.current_state === 'ERROR') {
              setShowAlert({ mssg: response.data.message, isOpen: true, type: 'error' });
              setValid(false)
              setFlag(false)
              setDpNetworkCallMessage(response.data.message)
            } else {
              if(key === 'fromField') debounceChangeHandler('PATTERN',val)
               if(key === 'fromModal'){
                setFlag(true)
                 setDpNetworkCallMessage(response.data.message)
              }
               setValid(true)
             }
          }
        })
      }
    
  };
  // Handles changes to the data depot dropdown.
  // const handleDataDepotChange = (val) => {
  //   if (val) {
  //     dispatch(
  //       api.endpoints.getDataDepotFieldList.initiate({
  //         account: queryParams.account,
  //         dataDepotName: val,
  //       },{forceRefetch:true})
  //     ).then((response) => {
  //       if (response?.data?.current_state === "SUCCESS") {
  //         const dataField = Object.values(response?.data?.data.data_field_list);
  //           setDepotField(dataField);
  //           if (!dataField?.filter( e => e?.name === selectedNode?.DATA_DEPOT_FIELD)?.length || !selectedNode?.DATA_DEPOT_FIELD) { // Changed because response is also coming in object format
  //             setDataFieldValue(dataField[0]?.name);
  //             dataDepotHandler("DATA_DEPOT_FIELD", dataField[0]?.name);
  //           } else {
  //             setDataFieldValue(selectedNode.DATA_DEPOT_FIELD);
  //           }
          
  //       } else if (response.data.current_state === "ERROR") {
  //         setShowAlert({ mssg: response.data.message, isOpen: true, type: 'error' });
  //         setDepotField([]);
  //         setAddDataDepot(true);
  //         dataDepotHandler("DATA_DEPOT_FIELD", "");

  //       }
  //     });
  //   }
  // };
  // Handle initial value of  DATA_DEPOT and DATA_DEPOT_FIELD
 
  // const dataDepotHandler = (key, val,deleteDataDepo) => {
  //   let newData = cloneDeep(translatedData);
  //   eachDeep(newData, (obj) => {
  //     if (obj?.key === selectedNode.key) {
  //       if (key === "DATA_DEPOT") {
  //         obj[key] = val;
  //       } else if (key === "DATA_DEPOT_FIELD") {
  //         setDataFieldValue(val);
  //         obj[key] = val;
  //         // Update the DATA_DEPOT value if it is not already set
  //         if (!obj.DATA_DEPOT) {
  //           obj.DATA_DEPOT = dataDepotValue;
  //         }
  //       }else if(deleteDataDepo){
  //         if(obj?.DATA_DEPOT) delete obj.DATA_DEPOT
  //         if(obj?.DATA_DEPOT_FIELD) delete obj.DATA_DEPOT_FIELD
  //       } else {
  //         obj[key] = dataFieldValue;
  //       }
  //     }
  //   });
  //   dispatch(
  //     treeActions.setNewRightTreeTranslatedData({
  //       screen: parentScreen,
  //       type: rightTree.currentTab,
  //       data: newData,
  //     })
  //   );
  // };
  

  // Change icon for XML Element if Repeating Element is checked
  // const handleRepeatingElement = (val) => {
  //   let newData = cloneDeep(translatedData);
  //   eachDeep(newData, (obj) => {
  //     if (obj?.key === selectedNode?.key) {
  //       if (obj?.ICON_DISPLAY === 'ELEMENT' && obj?.children?.length === 0 && val) {
  //         obj.ICON_DISPLAY = 'REPEATING_ELEMENT';
  //         obj.REPEATING = true
  //       } else if (obj?.ICON_DISPLAY === 'REPEATING_ELEMENT' && obj?.children?.length > 0) {
  //         obj.ICON_DISPLAY = 'ELEMENT';
  //         obj.REPEATING = false;
  //       } else if (obj?.ICON_DISPLAY === 'REPEATING_ELEMENT' && obj?.children?.length === 0 && !val) {
  //         obj.ICON_DISPLAY = 'ELEMENT';
  //         obj.REPEATING = false
  //       }
  //     }
  //   });
  //   dispatch(
  //     treeActions.setNewRightTreeTranslatedData({
  //       screen: parentScreen,
  //       type: rightTree.currentTab,
  //       data: newData,
  //     })
  //   );
  // }

  // Change handler for all field properties
  const submitChange = (key, val) => {
    if (
      key !== "MAPNAME" &&
      key !== "DESCRIPTION" &&
      key !== "FIELDTYPE" &&
      key !== "PRECISION" &&
      // key !== "DATA_DEPOT" &&
      // key !== "DATA_DEPOT_FIELD" &&
      key !== "PATTERN" &&
      key !== "VALUE" &&
      key !== "ATTRIBUTE_NAME" &&
      key !== "ELEMENT_NAME" &&
      key !== "REPEATING" &&
      key !== 'ELEMENT' &&
      key !== 'TABLE_NAME' &&
      key !== 'COLUMN_NAME' &&
      key !== 'ATTRIBUTE' && 
      key !== 'DATA_TYPE' &&
      key !== 'ELEMENT_ID' &&
      key !== 'FIELD_ID'
    )
      return;
    const parentArray = getParentArray(
      selectedNode.key.split("-").slice(0, -1).join("-"),
      translatedData
    );
    let isDuplicateMapName = false;
    if (key === "MAPNAME") {
      isDuplicateMapName = parentArray.some(
        (ele) =>
          ele.key !== selectedNode.key &&
          val.localeCompare(ele[key], undefined, { sensitivity: "accent" }) ===
            0
      );
    }

    if (isDuplicateMapName && val) {
      setFieldName(val);
      setErrorModal(true);
      return;
    }

    if (key === 'ELEMENT') {
      debounceChangeHandler("ELEMENT_NAME", val);
    }

    let isDuplicateElementName = false;
    if (key === 'ELEMENT_NAME') {
      isDuplicateElementName = parentArray.some(
        (element) =>
          element.key !== selectedNode.key &&
          (val === element[key] || val === element?.TYPE || val === element?.MAPNAME)
      );
    }
    if (isDuplicateElementName && val) {
      return;
    }

    if (key === 'ATTRIBUTE') {
      debounceChangeHandler("ATTRIBUTE_NAME", val);
    }

    const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
      if (objValue?.key !== selectedNode.key) {
        return;
      }
      if (key === "MAPNAME") {
        if (!description) {
          objValue.DESCRIPTION = objValue.COLUMN_NAME ? objValue.COLUMN_NAME : getUnnamedMapName(parentArray);
          objValue.title = `${t('LBL_FIELD')} ${objValue.COLUMN_NAME ? objValue.COLUMN_NAME :getUnnamedMapName(parentArray)}`;
        } else if (description !== val) objValue.DESCRIPTION = description;
        else if (description === val && objValue?.hasOwnProperty("DESCRIPTION")) {
          delete objValue.DESCRIPTION;
        } 
        objValue[key] = val || getUnnamedMapName(parentArray);
      } else if (key === "DESCRIPTION") {
          objValue[key] = (!val && objValue.COLUMN_NAME) ? objValue.COLUMN_NAME : val || selectedNode.MAPNAME;
          objValue.title = `${t('LBL_FIELD')}${objValue.FIELDTYPE === "CONSTANT" && !objValue.COLUMN_NAME
              ? `(${t("CONSTANT")})`
              : ""
            } ${objValue[key]}`;
          if (val === objValue.MAPNAME && objValue?.hasOwnProperty("DESCRIPTION")) delete objValue.DESCRIPTION; 
      }else if (key === "FIELDTYPE") {
        if (val !== "DATE" && objValue?.["PATTERN"]) delete objValue?.["PATTERN"] ;
        else if (!["INTEGER", "PACKED_INT", "ZONED_INT", "FLOAT"].includes(val) && objValue?.["PRECISION"]) {
          delete objValue?.["PRECISION"];
          delete objValue.ROUND;
          setPrecision('');
        }
        if (["INTEGER", "PACKED_INT", "ZONED_INT", "FLOAT", "BIT_FLAG"].includes(val)) {
          objValue["PRECISION"] = objValue?.["PRECISION"] || '0'
          objValue.ROUND = 'TRUE'
        }
        if (val === "CONSTANT" && templateHeader?.FILETYPE !== "XML") {
          objValue.title = `${t('LBL_FIELD')}${!objValue.COLUMN_NAME ? `(${t("CONSTANT")})` : ""} ${objValue.DESCRIPTION}`;
          objValue[key] = val;
        } 
        else if (val=== "SELECT" ){
          objValue[key] = "ALPHA";
          delete objValue.PRECISION;
          delete objValue.ROUND;
        }
        else {
          objValue.title = objValue.title.replace(`(${t("CONSTANT")})`, "");
          objValue[key] = val;
        }
      } else if (key === 'ATTRIBUTE_NAME') {
        const newName = !val ? getUnnamedMapName(parentArray) : t('UNNAMED');
        objValue.ATTRIBUTE_NAME = val || newName;
        objValue.MAPNAME = val || newName;
        objValue.title = val || newName;
        objValue['ELEMENT_NAME'] = val || newName;
      } else if (key === 'ELEMENT_NAME') {
        
        if(objValue?.children?.length || objValue?.TYPE) {
          const newName = !val ? getNewElementName(rightTree?.tree) : t('UNNAMED');
          objValue.TYPE = val || newName;
          if (objValue.hasOwnProperty('ELEMENT_NAME')) delete objValue.ELEMENT_NAME;
          if (objValue.hasOwnProperty('MAPNAME')) delete objValue.MAPNAME;
          objValue.title = `<${val || newName}>`;
        }
        else {
          const newName = !val ? getNewElementName(rightTree?.tree) : t('UNNAMED');
          objValue.MAPNAME = val || newName;
          objValue.ELEMENT_NAME = val || newName;
          if (objValue.hasOwnProperty('TYPE'))  delete objValue.TYPE;
          objValue.title = `<${val || newName}>`;
        }
      } 
      else if(key === 'REPEATING'){
        if (props.property === "ELEMENT") {
          if (objValue?.ICON_DISPLAY === 'ELEMENT' && objValue?.children?.length === 0 && val) {
            objValue.ICON_DISPLAY = 'REPEATING_ELEMENT';
            objValue.TYPE = objValue?.ELEMENT_NAME || objValue?.MAPNAME || objValue?.TYPE;
            objValue.REPEATING = "TRUE";
            if (objValue.hasOwnProperty('ELEMENT_NAME')) delete objValue.ELEMENT_NAME;
            if (objValue.hasOwnProperty('MAPNAME')) delete objValue.MAPNAME;
          } else if (objValue?.ICON_DISPLAY === 'REPEATING_ELEMENT' && objValue?.children?.length > 0) {
            objValue.ICON_DISPLAY = 'ELEMENT';
            objValue.ELEMENT_NAME = objValue.TYPE || objValue?.ELEMENT_NAME || objValue?.MAPNAME;
            if (objValue.hasOwnProperty('MAPNAME'))  delete objValue.MAPNAME;
            if (objValue.hasOwnProperty('TYPE'))  delete objValue.TYPE;
            if (objValue.hasOwnProperty('REPEATING')) delete objValue.REPEATING;
          } else if (objValue?.ICON_DISPLAY === 'REPEATING_ELEMENT' && objValue?.children?.length === 0 && !val) {
            objValue.ICON_DISPLAY = 'ELEMENT';
            objValue.ELEMENT_NAME = objValue.TYPE || objValue?.ELEMENT_NAME || objValue?.MAPNAME;
            if (objValue.hasOwnProperty('MAPNAME'))  delete objValue.MAPNAME;
            if (objValue.hasOwnProperty('TYPE'))  delete objValue.TYPE;
            if (objValue.hasOwnProperty('REPEATING')) delete objValue.REPEATING;
          }
        }else {
          objValue.ICON_DISPLAY = val === "TRUE" ? "FIELD_LOOP" : "FIELD";
          objValue[key] =val;
          objValue.type = val === "TRUE" ? "FIELD_LOOP" : "FIELD";
        }
      }
      else if(key === 'DATA_DEPOT_FIELD' || key === 'PATTERN'){
        objValue[key]=val
      }
      else if (key === 'PRECISION'){
        objValue[key] = val
      } else if (key === 'FIELD_ID') {
        objValue[key] = val
      }
      else if (key === 'DATA_TYPE'){
        if(val === t('SELECT')){
          delete objValue[key]
       }
       else objValue[key] = val
      }else if(key === 'TABLE_NAME'){
        objValue[key] =val;
      }else if(key === 'COLUMN_NAME'){
        objValue[key] = val;
      }
      else objValue[key] = val || selectedNode[key];
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: objValue,
        })
      );
      if (isArray(objValue?.children)) {
        return objValue.children;
      }
    });
    // console.log(updatedData);
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };

  // This debounces text input into 500ms intervals, and passes
  // (key, val) to the 'submitChange' function. This will prevent unnecessary
  // re-rendering of the inbound tree when the user changes Field Name for example.
  // Reduced Debounce time because it is too much (BG-9113)
  const debounceChangeHandler = useCallback(debounce(submitChange, 200), [
    rightTree.currentTab,
    rightTree.tree,
  ]);

  //same field name error popup
  const errorModalHandler = () => {
    setErrorModal(!errorModal);
    setText(selectedNode.MAPNAME || "");
    setElement(selectedNode?.ELEMENT_NAME || selectedNode?.TYPE || '');
  };

  const errorRef = useRef();

  // This function is called when the user changes the value of the precision input field
  const handlePrecisionChange = (e) => {
    // Regular expression to match numbers only
    // const re = /^[0-9\b]+$/;
    const {name, value} = e.target;
    const errorState = validateOnFlow(name, value,{
      [name] : genericRules.numericRuleWithEmpty
    })

    setPrecision(value);
    setErrors((prev) => ({
      ...prev,
      ...errorState
    }))

    if(isEmpty(errorState) || !value){
      debounceChangeHandler("PRECISION", Number(e.target.value));
    }

    if(!isEmpty(errorState)){
      setTimeout(()=>{
        setPrecision((previousPrecisionValue) => {
          let val = previousPrecisionValue;
          val = val.replace(/\D/g, '');
          if(val.length > 9){
            val = val.substring(0,9);
          }
          return val;
        })
      },validateRevertTime)
    }
    
    if(errorRef.current){
      clearTimeout(errorRef.current);
    }

    errorRef.current = setTimeout(() => {
      setErrors((previousErrorState) => {
        const copyPrev = JSON.parse(JSON.stringify(previousErrorState));
        delete copyPrev[name];
        return copyPrev;
      })
    }, validationTime)

  };


  const focusChanges = (e) => {
    const {name, value } = e.target;
    let errorMessage;
    const parentArray = getParentArray(
      selectedNode.key.split("-").slice(0, -1).join("-"),
      translatedData
    );
    
    parentArray.forEach(ele=>{
      if (!value && ele?.key === selectedNode.key){
        if (name === "ELEMENT_NAME") setElement(ele?.ELEMENT_NAME || ele?.TYPE || ele?.MAPNAME);
        else setAttribute(ele?.ATTRIBUTE_NAME || ele?.MAPNAME);
      }
      if(value && ele?.key !== selectedNode?.key){
        if(name === "ELEMENT_NAME" && 
          (ele[name] === value || ele?.TYPE === value))
        {
          errorMessage=t('BOX_ELEM_NAMES_MUST_BE_UNIQUE')
          setElement(ele?.[name] || ele?.TYPE || ele?.MAPNAME);
        }
      }
    })

    if(errorMessage){
      setErrors(prev=>{
        return {...prev,[name]:errorMessage};
      });
      setTimeout(()=>{
        setErrors(prev=>{
          if(prev?.name) delete prev?.name;
          return prev;
        });
      },validationTime)
    }
  }

  const handleFieldIdentifer = (val) => {
    if (val) {
      const newDelimVal = delimDisplay(val, true)
      setFieldIdentifier(delimDisplay(newDelimVal, true));
      debounceChangeHandler('FIELD_ID', delimDisplay(newDelimVal, true));
    } else setFieldIdentifier(val)
  }

  const changeHandlerXML = (name,value,stateFunction) =>{
    const previousValue = name === 'ATTRIBUTE_NAME' ? selectedNode[name] || selectedNode?.MAPNAME : selectedNode[name] || selectedNode?.TYPE;
    
    const errorState = validateOnFlow(name, value,{
      [name] : ValidationRulesXML[name]
    })
    stateFunction(value);
    setErrors((prev) => ({
      ...prev,
      ...errorState
    }))

    if(isEmpty(errorState)){
      debounceChangeHandler(name, value);
    }

    if(!isEmpty(errorState)){
      setTimeout(()=>{
        stateFunction((previousPrecisionValue) => {
          let val = previousPrecisionValue;
          if (!(/^[A-Za-z]+$/).test(val[0])) val = previousValue;
          else if(val) val = val?.replace(/[^-a-zA-Z0-9.:_]/g, '_') || previousValue;
          else val = previousValue?.replace(/[^-a-zA-Z0-9.:_]/g, '_') || previousValue;
          debounceChangeHandler(name, val);
          return value ? val : '';
        })
      },validateRevertTime)
    }
    
    if(errorRef.current){
      clearTimeout(errorRef.current);
    }

    errorRef.current = setTimeout(() => {
      setErrors((previousErrorState) => {
        const copyPrev = JSON.parse(JSON.stringify(previousErrorState));
        delete copyPrev[name];
        return copyPrev;
      })
    }, validationTime)
  }
  const handleDescFocus = () => {
    if (description.startsWith("UNNAMED")) {
      const updatedData = eachDeep(cloneDeep(translatedData), (o) => {
        if (o?.key !== selectedNode.key) {
          return;
        }
        o.title = `${t("LBL_FIELD")}${text}`;
        setDescription(o.MAPNAME);
        if (o?.hasOwnProperty("DESCRIPTION")) delete o.DESCRIPTION;
        if (isArray(o?.children)) {
          return o.children;
        }
      });
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: updatedData,
        })
      );
    }
  };

  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  }

  //data depot code -
  const [updatedSelectedNode, setUpdatedSelectedNode] = useState({...selectedNode});

  const saveNewData = (newNode, sNode, tData) => {
    let nNode = {...newNode};
    let updatedData = eachDeep(cloneDeep(tData), (obj, key, parentArr, ctx) => {
      if (typeof obj !== 'object') return;
      if (obj?.nodeId && obj.nodeId === sNode.nodeId) {
        Object.keys(newNode).forEach((prop) => {
          if (newNode[prop] === "" || newNode[prop] === undefined || newNode[prop] === null) {
            delete obj[prop];
            delete nNode[prop];
          } else {
            if (prop.toUpperCase() === prop || prop === "title") obj[prop] = newNode[prop];
          }
        });
      }
    });

    //prevent unnecessary dispatch
    if (isEqual(tData, updatedData) || isEqual(newNode, sNode)) return;
    
    //set new trans data to updatedData.
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );

    //set selectedNode to match.
    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: {...nNode, avoidSelection: true},
      })
    );
  }

  const debouncedNodeSave = useCallback(
    debounce((node, sNode, tData) => saveNewData(node, sNode, tData), 150, true), []
  )

  //this can be used if inbound field properties gets logic upgrade later
  // const modifyUpdatedNode = (prop, val, values) => {
  //   if (val !== "" && val !== undefined) {
  //     setUpdatedSelectedNode(prev => {
  //       return prop ? {...prev, [prop]: val} : {...prev, ...values}
  //     });
  //   } else {
  //     setUpdatedSelectedNode(prev => {
  //       return {...prev, [prop]: null}
  //     });
  //   }
  // }

  useEffect(() => {
    if (!isEqual(selectedNode, updatedSelectedNode)) return setUpdatedSelectedNode({...selectedNode});
  }, [selectedNode]);

  useEffect(() => {
    if (!isEqual(selectedNode, updatedSelectedNode)) return debouncedNodeSave(updatedSelectedNode, selectedNode, translatedData); 
  }, [updatedSelectedNode]);
  
  return (
    <>
      {!isEmpty(rightTree.tree[rightTree.currentTab].selectedNode) ? (
        <Stack spacing={"15px"} className="tp-segment">
          {templateHeader?.FILETYPE === "DATABASE" && (
            <DatabaseFieldProperty handleChange={debounceChangeHandler} />
          )}
          {templateHeader?.FILETYPE === "XML" && (
            <>
              {props?.property === "ELEMENT" && (
                <FormControl className="width-100" size="small">
                  <TextField
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    type="text"
                    className={"width-100"}
                    label={t("LBL_ELEM_NAME")}
                    name={"ELEMENT_NAME"}
                    value={element}
                    onBlur={focusChanges}
                    onChange={(e) => {
                      changeHandlerXML("ELEMENT_NAME",e.target.value,setElement)
                    }}
                    helperText={errors?.ELEMENT_NAME}
                    error={has(errors,"ELEMENT_NAME")}

                  />
                </FormControl>
              )}
              {props?.property === "ATTRIBUTE" && (
                <FormControl className="width-100" size="small">
                  <TextField
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    type="text"
                    className={"width-100"}
                    label={t("LBL_ATTR_NAME")}
                    name={"ATTRIBUTE_NAME"}
                    value={attribute}
                    onBlur={focusChanges}
                    onChange={(e) => {
                      changeHandlerXML("ATTRIBUTE_NAME",e.target.value,setAttribute);
                    }}
                    helperText={errors?.ATTRIBUTE_NAME}
                    error={has(errors,"ATTRIBUTE_NAME")}
                  />
                </FormControl>
              )}
              
            </>
          )}
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel id="ftDropdownLabel">{t("LBL_FLD_TYPE")}</InputLabel>
            <Select
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name={"FIELDTYPE"}
              value={fieldTypeDropDownItems?.length ? fieldType : ''}
              labelId="ftDropdownLabel"
              label={t("LBL_FLD_TYPE")}
              id="ftDropdown"
              size="small"
              onChange={(e) => {
                handlePatternPrecisionState(e);
                setFieldType(e.target.value);
                debounceChangeHandler("FIELDTYPE", e.target.value);
              }}>
              {fieldTypeDropDownItems}
            </Select>
          </FormControl>
          
          {(templateHeader.FILETYPE === "HL7" ) && (
            <FieldPropHL7Datatype/>
          )}
          
          {templateHeader?.FILETYPE !== "XML" && (
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                autoComplete="off"
                label={t("LBL_FLD_NAME")}
                type="text"
                className={"uppercase-input width-100"}
                name={"MAPNAME"}
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                  debounceChangeHandler("MAPNAME", (e.target.value || "")?.toUpperCase());
                }}
                onBlur={handleDescFocus}
              />
            </FormControl>
          )}
          {templateHeader?.FILETYPE !== "XML" && (
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                autoComplete="off"
                label={t("LBL_DESC")}
                type="text"
                className={"width-100"}
                name={"DESCRIPTION"}
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  debounceChangeHandler("DESCRIPTION", e.target.value);
                }}
                // onFocus={handleDescFocus}
              />
            </FormControl>
          )}
          {isNumericField && templateHeader.FILETYPE !== "XML" && (
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                type="text"
                autoComplete="off"
                label={t("LBL_PRECISION")}
                className={"uppercase-input width-100 mui-HelperText"}
                name={'PRECISION'}
                value={precision}
                onChange={(e) => {
                  handlePrecisionChange(e);
                }}
                onBlur={(e) => {
                  setPrecision(e.target.value.replace(/^0+(?=\d)/, ""));
                }}
                helperText={errors?.PRECISION}
                error={has(errors,"PRECISION")}
              />
            </FormControl>
          )}
          {isDateField && (
            <FormControl className="width-100" size="small">
              <Stack direction={"row"} spacing={"4px"}>
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_PATTERN")}
                  className={"width-100"}
                  value={date}
                  error={!valid}
                  helperText={dpNetworkCallMessage}
                  onChange={(e) => {
                    setDate(e.target.value);
                    debounceChangeHandler("PATTERN",e.target.value);
                    setDatePattern(e.target.value)
                    setDpNetworkCallMessage('');
                    setFlag(false)
                    setValid(true)
                  }}
                  onBlur={()=>{
                    // testDateHandler("fromField",date);
                  }}
                />
                <Button
                  variant="outlined"
                  size="small"
                  disableElevation
                  sx={{
                    width: "40px",
                    // padding: "4px 8px",
                    minWidth: "40px",
                  }}
                  onClick={() => setDatePatternModal(true)}>
                  {/* <MoreHorizIcon fontSize="small" /> */}
                  <CalendarMonthOutlinedIcon fontSize="small"></CalendarMonthOutlinedIcon>

                </Button>
              </Stack>
            </FormControl>
          )}

          {(templateHeader?.FILETYPE === "FIXED_LENGTH" || (templateHeader?.FILETYPE === "DELIM_FLD_ID" && rightTree.currentTab === "header")) && (
            <FixedLengthFieldProperty
              length={length}
              end={end}
              begin={begin}
              setLength={setLength}
              setEnd={setEnd}
              setBegin={setBegin}
            />
          )}

            {templateHeader?.FILETYPE !== "XML" && (
              <FormControl className="width-100" size="small">
                {/* Read-only field */}
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_FLD_NUM")}
                  disabled
                  className={"width-100"}
                  name={"FIELDNUMBER"}
                  value={fieldNumber}
                />
              </FormControl>
            )}

          {/* Constant Field */}
          {fieldType === "CONSTANT" && templateHeader?.FILETYPE !== "XML" && (
            <FormControl size="small">
              {/* Read-only field */}
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_CONST_VAL")}
                className={"width-100"}
                name={"VALUE"}
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  debounceChangeHandler("VALUE", e.target.value);
                }}
              />
            </FormControl>
          )}
          {(templateHeader?.FILETYPE === 'DELIM_FLD_ID' && rightTree.currentTab !== "header") && <FormControl className="width-100" size="small">
            <div className="flex">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_FIELD_ID")}
                type="text"
                className={"width-100"}
                name={"LBL_FIELD_ID"}
                value={fieldIdentifier || ''}
                onChange={(e) => {
                  setFieldIdentifier(e.target.value);
                  debounceChangeHandler('FIELD_ID', e.target.value);
                }}
              />
              <Button
                variant="outlined"
                size="small"
                className="margin-left-4"
                sx={{
                  width: "40px",
                  padding: "4px 8px",
                  minWidth: "40px",
                }}
                onClick={() => setOpenFieldIdentifier(true)}
                >
                <MoreHorizIcon fontSize="small" />
              </Button>
            </div>
          </FormControl>}
          <DelimiterDialog
            modalOpen={openFieldIdentifier}
            close={() => setOpenFieldIdentifier(false)}
            handleInput={handleFieldIdentifer}
            val={fieldIdentifier || ''}
            name={'DELIM_FLD_ID'}
          >
          </DelimiterDialog>
          
          {(["HL7", "MULIT_DELIMITED"].includes(templateHeader?.FILETYPE) || (templateHeader.FILETYPE === 'DELIM_FLD_ID' && rightTree.currentTab !== 'header')) &&
            (!getParentNode(selectedNode, translatedData) ||
              !["FIELD_GROUP", "REPEATING_FIELD_GROUP"].includes(getParentNode(selectedNode,translatedData)?.ICON_DISPLAY)) && (
              <FormControl>
                <TPCheckbox
                  label={t("BTN_FLD_REPEATABLE")}
                  checked={repeatableField}
                  handleCheck={(checked) => {
                    setRepeatableField(checked);
                    debounceChangeHandler("REPEATING", checked ? "TRUE" : "FALSE");
                  }}
                />
              </FormControl>
            )}
          {templateHeader?.FILETYPE === 'EDI' && <EDIFieldProperty 
            handleChange={debounceChangeHandler} 
            checked={repeatableField} 
            setChecked={setRepeatableField} />}

          <FormGroup>
            {"JSON" === templateHeader?.FILETYPE && (
              <TPCheckbox
                label={t("BTN_JSON_ARRAY")}
                checked={arrayValue}
                handleCheck={(checked) => {
                  setArrayValue(checked);
                  debounceChangeHandler("REPEATING", checked ? "TRUE" : "FALSE");
                }}
              />
            )}
            {/* <TPCheckbox
              label={t("BTN_ADD_TO_DATA_DEPOT")}
              checked={addDataDepot}
              handleCheck={(checked) => {
                if (!checked) dataDepotHandler(null,null,true);
                setAddDataDepot(checked);
              }}
            /> */}
            {updatedSelectedNode && 
              <AddToDataDepot updatedSelectedNode={updatedSelectedNode} setUpdatedSelectedNode={setUpdatedSelectedNode} templateType="inbound"/>
            }
            
            {templateHeader.FILETYPE === "XML" &&
              selectedNode?.children?.length === 0 &&
              selectedNode?.key?.split('-')?.length !== 3 && selectedNode.ICON_DISPLAY !== "ATTRIBUTE" &&(
                <TPCheckbox
                  label={t("BTN_REPEATING_ELEMENT")}
                  checked={repeatableField}
                  handleCheck={(checked) => {
                    debounceChangeHandler("REPEATING", checked)
                    setRepeatableField(checked);
                  }}
                />
            )}
          </FormGroup>
        </Stack>
      ) : (
        <div className="height-100">
          <div className="panel-no-data">{t('NO_FLD_SELECTED')}</div>
        </div>
      )}

      {/* Error Modal */}
      <Dialog
        open={errorModal}
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle className="dialog-header">
          <div className="title">{t("ERROR")}</div>
        </DialogTitle>
        <DialogContent dividers>{
          templateHeader.FILETYPE === "XML" ? t('BOX_ELEM_NAMES_MUST_BE_UNIQUE') : duplicateMapNameMessage
        }</DialogContent>
        <DialogActions>
          <Button size="small" onClick={errorModalHandler} variant={"outlined"}>
            {t("BTN_OK")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Generic DatePattern */}
      <DatePattern
        openModal={datePatternModal}
        docPath={docPath}
        okHandler={datePatternModalOkHandler}
        cancelHandler={datePatternModalCancelHandler}
        onChangeHandler={setDatePattern}
        testDateHandler={testDateHandler}
        dpNetworkCallMessage={dpNetworkCallMessage}
        datePattern={datePattern}
        valid={valid}
      />
      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
    </>
  );
}
export const getUnnamedMapName = (parentArray) => {
  let unnamedCount = 0;
  const data = cloneDeep(parentArray);
  const getMapName = (data) => {
    data.forEach((ele) => {
      if (ele.MAPNAME && ele.MAPNAME.startsWith(t("UNNAMED"))) {
        const latestUnnamedMapName = +ele.MAPNAME.slice(t("UNNAMED").length);
        if (!isNaN(latestUnnamedMapName)) {
          unnamedCount =
            latestUnnamedMapName > unnamedCount
              ? latestUnnamedMapName
              : unnamedCount;
        }
      }
      if (ele?.children?.length > 0) {
        getMapName(ele.children);
      }
    });
  };

  getMapName(data);
  return `${t("UNNAMED")}${Number(unnamedCount) + 1}`;
};

export const delimDisplay = (val, modal) => {
    
  // Display values in certain ways depending on a few specific conditions:
  // - If no delim val -> 'No Delimiter Chosen'.
  // - Replace 'CR' and 'LF' (ascii 13 and 10) OR '%0D' '%0A' -> display 'CR', 'LF', 'CRLF' in latin characters.
  // - If val is one or two char length -> display 'ASCII 42 (*)' delimited by comma.
  // - else -> display the decoded string (even if it's just empty chars ?)
  if(val === undefined) return '';
  if (!modal) {
    if (typeof val === 'boolean'|| val === t('TXT_NO_DELIM_CHOSEN') || !val) return t('TXT_NO_DELIM_CHOSEN');
  }
  if (val === "CR" || val === "%0D" || val === "\r") return "CR";
  if (val === "LF" || val === "%0A" | val === "\n" ) return "LF";
  if (val === "CRLF" || val === "%0D%0A") return "CRLF";

  try { val = decodeURIComponent(val) } 
  catch (e) { 
    //case - malformed URI
    //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
  }
  return val.length < 3 ?
    val.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join(', ')
    : val;
}


export const getParentArray = (parentKey, translatedData) => {
  let nestedNodes = parentKey.split("-");
  nestedNodes = nestedNodes?.splice(1);

  const data = cloneDeep(translatedData);
  let finalArray = [];

  const getArray = (translatedData, nodes) => {
    if (nodes?.length === 0) {
      const { children } = translatedData;
      finalArray = children ? children : translatedData;
      return;
    }

    const isArray = Array.isArray(translatedData);
    if (isArray) {
      const nestedData = translatedData[[nodes?.[0]]];
      const newNestedNodes = nodes?.splice(1);
      getArray(nestedData, newNestedNodes);
    } else getArray(translatedData?.children, nodes);
  };
  getArray(data, nestedNodes);
  return finalArray;
};

export const getParentNode = (selectedNode, translatedData) =>{
  let node;
  let found = false;
   const parentKey = selectedNode.key.split("-").slice(0, -1).join("-")
   eachDeep(cloneDeep(translatedData),(obj) =>{
    if(found) return;
    if(obj && obj.key && obj.key === parentKey){
      node = obj
      found = true;
      return false;
    }
    
    if (isArray(obj?.children)) {
      return obj.children;
    }
   })
   return node;
}